import { render, staticRenderFns } from "./Negotiations.vue?vue&type=template&id=4f9fac1a&"
import script from "./Negotiations.vue?vue&type=script&lang=js&"
export * from "./Negotiations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports